import { render, staticRenderFns } from "./FolImportacaoPrincipal.vue?vue&type=template&id=b09cba0a&"
import script from "./FolImportacaoPrincipal.vue?vue&type=script&lang=js&"
export * from "./FolImportacaoPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports